import React, { FC, useEffect } from 'react'

import { useSessionLanguage } from '@context/SessionSettingsContext'

import { mapToTradingViewLocale } from '@global/locale/Locale'

interface TradingViewBrokerReviewWidgetProps {
  isGrid?: boolean
  isDark?: boolean
}

export const TradingViewBrokerReviewWidget: FC<TradingViewBrokerReviewWidgetProps> = ({
  isGrid,
  isDark,
}) => {
  const locale = useSessionLanguage()
  const tradingViewLocale = mapToTradingViewLocale(locale)

  useEffect(() => {
    const script = document.createElement('script')
    script.src = `https://www.tradingview-widget.com/widget/broker-reviews.js?locale=${tradingViewLocale}broker=tickmill`
    script.async = true
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [tradingViewLocale])

  return React.createElement('tv-broker-reviews', {
    mode: isGrid ? 'grid' : 'carousel',
    broker: 'tickmill',
    theme: isDark ? 'dark' : 'light',
    lang: tradingViewLocale,
    transparent: false,
    style: isGrid ? { height: 'auto' } : undefined,
    'show-broker-name': true,
  })
}
